var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import InfoOutlined from '@pf-ui/pf-icons-react/InfoOutlined';
import SuccessOutlined from '@pf-ui/pf-icons-react/SuccessOutlined';
import ErrorOutlined from '@pf-ui/pf-icons-react/ErrorOutlined';
import AlertOutlined from '@pf-ui/pf-icons-react/AlertOutlined';
import LoadingFilled from '@pf-ui/pf-icons-react/LoadingFilled';
import { Notice } from 'rc-notification';
import classNames from 'classnames';
import useStyle from './style';
import { ConfigContext } from '../config-provider';
export const TypeIcon = {
    info: React.createElement(InfoOutlined, null),
    success: React.createElement(SuccessOutlined, null),
    error: React.createElement(ErrorOutlined, null),
    warning: React.createElement(AlertOutlined, null),
    loading: React.createElement(LoadingFilled, null),
};
export function PureContent({ prefixCls, type, icon, children }) {
    return (React.createElement("div", { className: classNames(`${prefixCls}-custom-content`, `${prefixCls}-${type}`) },
        icon || TypeIcon[type],
        React.createElement("span", null, children)));
}
/** @private Internal Component. Do not use in your production. */
export default function PurePanel(props) {
    const { prefixCls: staticPrefixCls, className, type, icon, content } = props, restProps = __rest(props, ["prefixCls", "className", "type", "icon", "content"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const [, hashId] = useStyle(prefixCls);
    return (React.createElement(Notice, Object.assign({}, restProps, { prefixCls: prefixCls, className: classNames(className, hashId, `${prefixCls}-notice-pure-panel`), eventKey: "pure", duration: null, content: React.createElement(PureContent, { prefixCls: prefixCls, type: type, icon: icon }, content) })));
}
